import client from "./client";

const getSubsidiaries = () => client.get("subsidiary/all/paginated");
const getSubsidiaryCustomizeConfig = (subId) =>
  client.get(`subsidiary/${subId}/config/customize`);
// const getSubsidiaryDetails = (id) =>
//   client.get(`subsidiary/fetch?subsidiaryId=${id}`);
const getSubsidiaryDetails = (subId) =>
  client.get(`business/details?BusinessId=${subId}`);
const configureSubsidiaryCustomizeConfig = (subId, payload) =>
  client.post(`subsidiary/${subId}/config/customize`, payload);
const updateSubsidiaryConfig = (subId, payload) =>
  client.post(`subsidiary/${subId}/config/set`, payload);

export default {
  getSubsidiaries,
  getSubsidiaryCustomizeConfig,
  getSubsidiaryDetails,
  configureSubsidiaryCustomizeConfig,
  updateSubsidiaryConfig,
};
